module.exports = __webpack_public_path__ + "img/logo.fa7e2eb7.svg";